import { useEffect, useState } from "react";
import { env } from "@/app/_utils/env";

export default function DevBanner() {
  const [info, setInfo] = useState<{ db: string; connection_url: string } | null>(null);

  useEffect(() => {
    fetch(`${env.apiBaseUrl}env/`)
      .then((r) => r.json())
      .then((data) => {
        if (data.is_test) setInfo({ db: data.db, connection_url: data.connection_url });
      })
      .catch(() => {});
  }, []);

  if (!info) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        backgroundColor: "#f59e0b",
        color: "#1c1917",
        textAlign: "center",
        padding: "4px 0",
        fontSize: "12px",
        fontWeight: 600,
        letterSpacing: "0.05em",
        pointerEvents: "none",
      }}
    >
      TEST DB — {info.connection_url}
    </div>
  );
}
